import useCompanionAccess from '../hooks/useCompanionAccess';
import { Avatar } from '@mui/joy';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { Menu, MenuItem, styled } from '@mui/material';
import Badge from '@mui/material/Badge';
import React, { useContext, useEffect, useState } from 'react';
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import LOGO from '../assets/img/logo.png';
import { pictos } from '../assets/img/pictos';
import { LoggedContext, NotifNbreContext } from '../Context';
import { PoliceDefaut } from '../helpers/contants';
import { deconnexion } from '../pages/fonctions';
import { resetUser } from '../redux/authSlice';
import { resetEvenements } from '../redux/evenementsSlice';
import { exitCompanion } from '../redux/companionSlice';
import { resetProfil } from '../redux/profilSlice';
import '../styles/navigation.css';
import DashboardButton from './DashboardButton';
import DashboardMenu from './DashboardMenu';

const Navigation = props => {
  const { isCompanion, requireAccount } = useCompanionAccess(props.companion);
  //Déconnexion
  const loggedContext = useContext(LoggedContext);
  const navigationPage = useNavigate();

  const dispatch = useDispatch();

  const eventSelected = useSelector(state =>
    state.evenements.evenementSelect && state.evenements.evenementSelect.id
      ? state.evenements.evenementSelect.id
      : ''
  );

  const nbreNotif = useContext(NotifNbreContext);

  const isMobileMenu = () => window.matchMedia('(max-width: 911px)').matches;
  const [menuOpen, setMenuOpen] = useState(() => {
    if (!isMobileMenu()) return true;
    return sessionStorage.getItem('neo_mobile_side_menu_open') !== 'false';
  });
  const toggleMenu = () =>
    setMenuOpen(previous => {
      const next = !previous;
      if (isMobileMenu()) {
        sessionStorage.setItem('neo_mobile_side_menu_open', String(next));
        sessionStorage.setItem('neo_mobile_side_menu_seen', 'true');
      }
      return next;
    });

  useEffect(() => {
    if (
      !props.button ||
      !menuOpen ||
      !isMobileMenu() ||
      sessionStorage.getItem('neo_mobile_side_menu_seen') === 'true'
    ) {
      return undefined;
    }
    const timeout = window.setTimeout(() => {
      sessionStorage.setItem('neo_mobile_side_menu_open', 'false');
      sessionStorage.setItem('neo_mobile_side_menu_seen', 'true');
      setMenuOpen(false);
    }, 2000);
    return () => window.clearTimeout(timeout);
  }, [menuOpen, props.button]);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleContacts = () => {
  //     contactsRedux(userToken)
  //         .then((reponse) => {
  //             // console.log(reponse.data)

  //             dispatch(
  //                 {
  //                     type: 'Profil/addContacts',
  //                     payload: reponse.data
  //                 }
  //             );

  //             demandesRedux(userToken)
  //                 .then((reponse) => {
  //                     // console.log(reponse.data)

  //                     dispatch(
  //                         {
  //                             type: 'Profil/addDemandes',
  //                             payload: reponse.data
  //                         }
  //                     );

  //                 })

  //             invitationsRedux(userToken)
  //                 .then((reponse) => {
  //                     // console.log(reponse.data)

  //                     dispatch(
  //                         {
  //                             type: 'Profil/addInvitations',
  //                             payload: reponse.data
  //                         }
  //                     );

  //                 })

  //             navigationPage('/contacts')

  //         }).catch((erreur) => {
  //             if (erreur.response) {
  //                 if (erreur.response.status === 401) {
  //                     refreshToken(refresh_token).then(
  //                         async (reponse) => {
  //                             dispatch(
  //                                 {
  //                                     type: 'user/addRefresh',
  //                                     payload: reponse.data.refresh
  //                                 }
  //                             );
  //                             dispatch(
  //                                 {
  //                                     type: 'user/addAccess',
  //                                     payload: reponse.data.access
  //                                 }
  //                             )
  //                             console.log('token refresh...')
  //                             handleContacts()
  //                         })

  //                 }

  //             }
  //         })

  // }

  const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
      right: 23,
      top: 9,
      border: '1px solid white',
      padding: '0 4px',
      backgroundColor: 'red',
      color: 'white',
      fontFamily: PoliceDefaut,
      // fontSize: '1rem',
      height: 'auto',
      paddingTop: '5%',
      paddingBottom: '5%',
      textAlign: 'center',
    },
  }));

  const logout = () => {
    deconnexion(loggedContext, navigationPage);
    dispatch(resetUser());
    dispatch(resetEvenements());
    dispatch(resetProfil());
    nbreNotif.setNbre(0);
  };

  const handleChangeEvent = () => {
    if (isCompanion) {
      dispatch(exitCompanion());
      dispatch(resetEvenements());
      navigationPage('/companion');
      return;
    }
    if (requireAccount('Changer d’événement')) return;
    dispatch(resetEvenements());
    navigationPage('/main');
  };
  return (
    <Container className="navbar-container pb-4" fluid>
      {/* // <Container
    //   className="navbar-container mb-2 pb-4"
    //   style={{
    //     // background: `url(./bandeau.jpg)`,
    //     // backgroundPositionX: 600,
    //     backgroundPositionX: -600,
    //     backgroundRepeat: "no-repeat",
    //   }}
    //   fluid
    // > */}
      {props.button ? <DashboardButton menuOpen={menuOpen} onToggle={toggleMenu} /> : <></>}
      {props.button ? (
        <DashboardMenu selected={props.selected} open={props.open} menuOpen={menuOpen} />
      ) : (
        <></>
      )}

      {/* Menu notifications  */}
      {/* <Notification anchorEl={anchorEl2} handleClose={handleCloseNotif} open={open2} /> */}

      <Menu
        className="menu-profil"
        id="profil-menu"
        aria-labelledby="btn-profil"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        disableScrollLock={true}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {props.profile ? null : (
          <MenuItem
            onClick={() => navigationPage(isCompanion ? '/login' : '/compte')}
            style={{ fontFamily: PoliceDefaut }}
            className=""
          >
            {isCompanion ? 'Se connecter' : 'Mon profil'}
          </MenuItem>
        )}
        <MenuItem
          onClick={() => navigationPage('/parametres')}
          style={{ fontFamily: PoliceDefaut }}
        >
          Paramètres
        </MenuItem>
        <MenuItem
          onClick={() => navigationPage('/nousContacter')}
          style={{ fontFamily: PoliceDefaut }}
        >
          Nous contacter{' '}
        </MenuItem>
        {/* <MenuItem style={{ fontFamily: PoliceDefaut }}><NavLink to='' onClick={() => configInfos(userToken, dispatch, navigationPage, 'copyright')}>Agence BEC-copyright</NavLink> </MenuItem> */}
        <MenuItem
          onClick={() => navigationPage('/copyright/1')}
          style={{ fontFamily: PoliceDefaut }}
        >
          Conditions d'utilisation{' '}
        </MenuItem>
        {/* <MenuItem style={{ fontFamily: PoliceDefaut }}><NavLink to='' onClick={() => configInfos(userToken, dispatch, navigationPage, 'conditionsLegales')}>Mentions légales</NavLink> </MenuItem> */}
        <MenuItem
          onClick={() => navigationPage('/conditionsLegales/1')}
          style={{ fontFamily: PoliceDefaut }}
        >
          Mentions légales
        </MenuItem>
        <MenuItem
          onClick={() => navigationPage('/politiqueConfidentialite/1')}
          style={{ fontFamily: PoliceDefaut }}
        >
          Politique de confidentialité
        </MenuItem>
        <MenuItem
          onClick={() => logout()}
          style={{ fontFamily: PoliceDefaut }}
          className="border-top"
        >
          {isCompanion ? 'Quitter le mode invité' : 'Déconnexion'}
        </MenuItem>
      </Menu>
      <Row className="">
        <Navbar className="navbar-home">
          <Container fluid>
            <Navbar.Brand
              className="logoHome d-flex justify-content-start"
              style={{ marginLeft: '0px' }}
            >
              <Row className="">
                <Col
                  sm="auto"
                  className="d-flex justify-content-start"
                  style={{ width: 'fit-content' }}
                >
                  <NavLink to="/main" className="d-flex justify-content-end">
                    <img
                      src={LOGO}
                      alt=""
                      style={{
                        width: 'auto',
                        height: '90px',
                        marginTop: '8px', // Equivalent to mt-2
                        paddingTop: '4px',
                      }}
                    />
                  </NavLink>
                </Col>
                {eventSelected !== '' && props.evenement ? (
                  <Col
                    xs="auto"
                    className="p-0 bg bg-white mb-2 pt-2"
                    style={{
                      // Remove border radii for mobile using a media query hack in JS
                      borderBottomLeftRadius: '1.5rem',
                      borderBottomRightRadius: '1.5rem',
                      width: 'fit-content',
                      minWidth: '150px',
                      height: '100px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginLeft: '10px',
                      cursor: 'pointer',
                      ...(window.matchMedia && window.matchMedia('(max-width: 767px)').matches
                        ? {
                            marginTop: '0px',
                            marginLeft: '0px',
                            borderBottomLeftRadius: '0',
                            borderBottomRightRadius: '1.5rem',
                            borderTopLeftRadius: '0',
                            borderTopRightRadius: '1.5rem',
                          }
                        : {}),
                    }}
                    onClick={handleChangeEvent}
                    onKeyDown={e => e.key === 'Enter' && handleChangeEvent()}
                    role="button"
                    tabIndex={0}
                  >
                    <button
                      type="button"
                      onClick={e => {
                        e.stopPropagation();
                        handleChangeEvent();
                      }}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: 0,
                        marginBottom: '4px',
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: '#134491',
                        fontFamily: PoliceDefaut,
                        fontSize: '0.75rem',
                        cursor: 'pointer',
                      }}
                    >
                      <SwapHorizIcon sx={{ fontSize: 14 }} />
                      Changer d'événement
                    </button>
                    <img
                      className="evenement-navbar-icone"
                      src={props.evenement}
                      alt="evenement"
                      style={{
                        maxHeight: '65px',
                        maxWidth: '160px',
                        objectFit: 'contain',
                        cursor: 'pointer',
                      }}
                    />
                  </Col>
                ) : (
                  <Col
                    xs="auto"
                    className="p-0 mb-2 mt-2 d-none d-md-block"
                    style={{
                      width: '180px',
                      minWidth: '180px',
                      height: '90px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginLeft: '10px',
                    }}
                  ></Col>
                )}
              </Row>
            </Navbar.Brand>
            {props.menus ? (
              <Navbar.Collapse
                className="collapse"
                id="basic-navbar-nav"
                style={{
                  display: 'none',
                }}
              >
                <Nav className="me-auto collapse-menu  d-flex justify-content-end align-items-center">
                  <Nav.Item className="">
                    <div
                      className="d-flex"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (!requireAccount('Messages')) navigationPage('/messagerie');
                      }}
                    >
                      <div className="" sm="auto" style={{ width: 'fit-content' }}>
                        <img className="icone" style={{}} src={pictos.messagerie_icone} alt="" />
                      </div>
                      <div sm="auto" className="texteMenus d-flex align-items-center px-1">
                        {'Messages'}
                      </div>
                    </div>
                  </Nav.Item>

                  <Nav.Item className="">
                    <div
                      className="d-flex"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        if (!requireAccount('Contacts')) navigationPage('/contacts');
                      }}
                    >
                      <div className="" sm="auto" style={{ width: 'fit-content' }}>
                        <img
                          className="icone"
                          style={{}}
                          src={pictos.contacts_icone}
                          alt=""
                          width={'30px'}
                        />
                      </div>
                      <div sm="auto" className="texteMenus d-flex align-items-center px-1">
                        {'Contacts'}
                      </div>
                    </div>
                  </Nav.Item>
                  <Nav.Item className="">
                    <div
                      className="d-flex"
                      style={{ cursor: 'pointer' }}
                      id="btn-compte"
                      aria-controls={open ? 'profil-menu' : undefined}
                      aria-haspopup={true}
                      aria-expanded={open ? 'true' : undefined}
                      onClick={handleClick}
                    >
                      <div className="" sm="auto" style={{ width: 'fit-content' }}>
                        {props.photo ? (
                          <Avatar
                            src={props.photo}
                            style={{ height: '35px', width: '35px' }}
                            className="avatar-navigation mx-1"
                          />
                        ) : (
                          <img src={pictos.compte_icone} alt="" className="icone" width={'30px'} />
                        )}
                      </div>
                      <div sm="auto" className="texteMenus d-flex align-items-center px-1">
                        {isCompanion ? 'Invité' : 'Compte'}
                      </div>
                    </div>
                  </Nav.Item>
                  {!isCompanion && (
                    <Nav.Item style={{}} className="">
                      <Row>
                        <Col sm="auto">
                          <Row className="">
                            <NavLink to={'/notifications'}>
                              <Row className=" d-flex ">
                                <StyledBadge badgeContent={nbreNotif.nbre}>
                                  <img
                                    className="notif-icone icone"
                                    src={pictos.notification_icone}
                                    alt="Notifications"
                                  />
                                </StyledBadge>
                              </Row>
                            </NavLink>
                          </Row>
                        </Col>
                      </Row>
                    </Nav.Item>
                  )}
                </Nav>
              </Navbar.Collapse>
            ) : null}
          </Container>
        </Navbar>
      </Row>

      <Row className="d-flex justify-content-center mb-2 mt-4">
        <Row
          style={{ position: 'relative' }}
          className={props.main ? 'participant-picto mt-0 ' : 'participant-picto'}
        >
          <img
            src={props.icone}
            alt=""
            style={{
              position: 'absolute',
              zIndex: '1',
              width: '100px',
              height: 'auto',
              margin: 'auto',
            }}
          />
        </Row>
        {props.content}
        <Row className="participantTitle">
          <div className="">{props.titre}</div>
        </Row>
      </Row>
    </Container>
  );
};

export default Navigation;
